export default {
  createLoading: false,
  aiVyakhyaTextGenerateData: null,
  audioGenerateLoading: false
}
